import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as authActionCreators from '../../actions/auth';
import * as commonActionCreators from '../../actions/common';
let allActionCreators = Object.assign({}, authActionCreators, commonActionCreators);

import {HeaderContainer} from '../views/header/Header';
import RhinoAlert from './alert/RhinoAlert';


class AppAuth extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <div className='AppAuth'>
      <HeaderContainer />
      <div className='authBody'>
        {this.props.children}
      </div>
      <RhinoAlert open={this.props.common.alertOpen} alertText={this.props.common.alertText} closeMethod={::this.props.commonCloseAlert} />
    </div>;
  }
}
export default AppAuth;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    common: state.common,
  };
}

export const AppAuthContainer = connect(
  mapStateToProps,
  allActionCreators
)(AppAuth);

